var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-100 min-h-screen",attrs:{"id":"app"}},[_c('Notification'),_c('ModalsComponent'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }